import React, { useEffect, useState } from 'react';
import TranslatableField from '../../../TranslatableField';
import { Feedback, useSectionFeedback } from './sectionFeedback';

const TRANSLATIONS_ENDPOINT = '/v1/seller/storefront/translations';

export default function BasicsSection({ data, saving, onSave, actions }) {
    const basics = data?.basics || {};
    const [title, setTitle] = useState(basics.title || '');
    const [subtitle, setSubtitle] = useState(basics.subtitle || '');
    const [description, setDescription] = useState(basics.description || '');
    const { feedback, showFeedback } = useSectionFeedback();

    useEffect(() => {
        setTitle(basics.title || '');
        setSubtitle(basics.subtitle || '');
        setDescription(basics.description || '');
    }, [basics.title, basics.subtitle, basics.description]);

    function handleSave() {
        onSave(async () => {
            const result = await actions.saveBasics({ title, subtitle, description });
            showFeedback(result.success ? 'success' : 'error', result.success ? 'Basics saved.' : result.error);
            return result;
        });
    }

    return (
        <div>
            <div className="sfm-section-header">
                <h2>Landing Page Basics</h2>
                <p>Set the title, subtitle, and description for your storefront.</p>
            </div>
            <div className="group">
                <div className="translatable-label">
                    <label htmlFor="sfm-title">Title</label>
                    <TranslatableField
                        endpoint={TRANSLATIONS_ENDPOINT}
                        field="basics.title"
                        label="Title"
                        sourceValue={title}
                        defaultLanguage={data?.defaultLanguage}
                        maxLength={80}
                        translations={data?.translations}
                        onTranslationsChange={actions.setTranslations}
                    />
                </div>
                <input
                    id="sfm-title"
                    type="text"
                    value={title}
                    onChange={event => setTitle(event.target.value)}
                    placeholder="My Amazing Store"
                    maxLength={80}
                    aria-describedby="sfm-title-help"
                />
                <p id="sfm-title-help" className="help">The main headline displayed at the top of your landing page. Up to 80 characters.</p>
            </div>
            <div className="group">
                <div className="translatable-label">
                    <label htmlFor="sfm-subtitle">Subtitle</label>
                    <TranslatableField
                        endpoint={TRANSLATIONS_ENDPOINT}
                        field="basics.subtitle"
                        label="Subtitle"
                        sourceValue={subtitle}
                        defaultLanguage={data?.defaultLanguage}
                        maxLength={120}
                        translations={data?.translations}
                        onTranslationsChange={actions.setTranslations}
                    />
                </div>
                <input
                    id="sfm-subtitle"
                    type="text"
                    value={subtitle}
                    onChange={event => setSubtitle(event.target.value)}
                    placeholder="Handmade goods and digital products"
                    maxLength={120}
                    aria-describedby="sfm-subtitle-help"
                />
                <p id="sfm-subtitle-help" className="help">A short tagline shown below the title. Up to 120 characters.</p>
            </div>
            <div className="group">
                <div className="translatable-label">
                    <label htmlFor="sfm-description">Description</label>
                    <TranslatableField
                        endpoint={TRANSLATIONS_ENDPOINT}
                        field="basics.description"
                        label="Description"
                        sourceValue={description}
                        defaultLanguage={data?.defaultLanguage}
                        inputType="textarea"
                        maxLength={300}
                        translations={data?.translations}
                        onTranslationsChange={actions.setTranslations}
                    />
                </div>
                <input
                    id="sfm-description"
                    type="text"
                    value={description}
                    onChange={event => setDescription(event.target.value)}
                    placeholder="Tell shoppers about your store, what you sell, and what makes it special."
                    maxLength={300}
                    aria-describedby="sfm-description-help"
                />
                <p id="sfm-description-help" className="help">A brief store bio. Up to 300 characters.</p>
            </div>
            <div className="sfm-save-row">
                <button type="button" className="button primary" onClick={handleSave} disabled={saving}>Save Basics</button>
                <Feedback feedback={feedback} />
            </div>
        </div>
    );
}
